<template>
  <div style="display: flex; width: 100%; margin-left: 2px;">
    <div style="flex: 3.8;" >
      <h3>订单信息</h3>
      <el-descriptions :border="true" :column="3">
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-document" style="margin-right: 5px;"></i>订单编号
          </template>
          {{ order.orderSn }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-user" style="margin-right: 5px;"></i>归属人
          </template>
          {{ order.employee.adminName }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-time" style="margin-right: 5px;"></i>订单创建时间
          </template>
          {{ order.createTime }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-s-order" style="margin-right: 5px;"></i>订单状态
          </template>
          <el-tag v-if="order.orderState === 0" type="warning">待审核</el-tag>
          <el-tag v-else-if="order.orderState === 1" type="warning">待复审</el-tag>
          <el-tag v-else-if="order.orderState === 2" type="danger">审核未通过</el-tag>
          <el-tag v-else-if="order.orderState === 3" type="warning">待发货</el-tag>
          <el-tag v-else-if="order.orderState === 4" type="primary">已发货</el-tag>
          <el-tag v-else-if="order.orderState === 5" type="success">交易成功</el-tag>
          <el-tag v-else-if="order.orderState === 6" type="danger">订单取消</el-tag>
          <el-tag v-else-if="order.orderState === 7" type="warning">待终审</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-s-custom" style="margin-right: 5px;"></i>客户名称
          </template>
          {{ order.customer.customerName }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-phone" style="margin-right: 5px;"></i>客户手机号
          </template>
          {{ order.customer.phoneNumber }}
        </el-descriptions-item >
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-goods" style="margin-right: 5px;"></i>客户销售渠道
          </template>
          {{ gettypeNameById(order.customer.typeId) }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle'  :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-star-on" style="margin-right: 5px;"></i>客户级别
          </template>
          {{ getlabelNameById(order.customer.labelId) }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle'  :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-place" style="margin-right: 5px;"></i>客户来源
          </template>
          {{ getsourceNameById(order.customer.sourceId) }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-money" style="margin-right: 5px;"></i>订单总金额
          </template>
          {{ order.orderAmount }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle'  :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-wallet" style="margin-right: 5px;"></i>支付方式
          </template>
          {{ order.payType }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle'  :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-reading" style="margin-right: 5px;"></i>支付状态
          </template>
          {{ order.paymentStatus }}
        </el-descriptions-item>
<!--        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">-->
<!--          <template slot="label" >-->
<!--            <i class="el-icon-money" style="margin-right: 5px;"></i>欠款总金额-->
<!--          </template>-->
<!--          {{ order.orderAmount }}-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item :labelStyle='labelstyle'  :contentStyle="contentStyle">-->
<!--          <template slot="label" >-->
<!--            <i class="el-icon-wallet" style="margin-right: 5px;"></i>已还金额-->
<!--          </template>-->
<!--          {{ order.payType }}-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item :labelStyle='labelstyle'  :contentStyle="contentStyle">-->
<!--          <template slot="label" >-->
<!--            <i class="el-icon-reading" style="margin-right: 5px;"></i>剩余代还金额-->
<!--          </template>-->
<!--          {{ order.paymentStatus }}-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-map-location" style="margin-right: 5px;"></i>收货地址
          </template>
          {{ order.shippingAddress }}
        </el-descriptions-item>

        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-truck" style="margin-right: 5px;"></i>发货方式
          </template>
          {{ order.logisticsMethods }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-office-building" style="margin-right: 5px;"></i>快递公司
          </template>
          {{ order.logisticsCompanies }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-document" style="margin-right: 5px;"></i>快递单号
          </template>
          {{ order.trackingNumber }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-edit" style="margin-right: 5px;"></i>订单备注
          </template>
          {{ order.notes }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label" >
            <i class="el-icon-edit" style="margin-right: 5px;"></i>物流备注
          </template>
          {{ order.remarks }}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle='labelstyle' :contentStyle="contentStyle">
          <template slot="label">
            <i class="el-icon-picture" style="margin-right: 5px;"></i>收款凭证
          </template>
          <div v-if="order.receipt && order.receipt.length > 0" class="image-container">
            <el-image
                v-for="(image, imgIndex) in order.receipt"
                :key="imgIndex"
                :src="image"
                :preview-src-list="order.receipt"
                fit="contain"
                class="image-container-box"
            />
          </div>
          <div v-else class="no-images-message">
            暂时没有图片
          </div>
        </el-descriptions-item>
      </el-descriptions>
     <h3>订单还款</h3>
      <el-form :model="orderForm" label-width="90px" :rules="rules" ref="orderForm" label-position="right" class="border">
        <el-form-item label="支付状态:" prop="paymentStatus">
          <el-radio-group v-model="orderForm.paymentStatus" placeholder="请选择订单支付状态">
            <el-radio label="欠款" border size="medium">
              <i class="el-icon-warning icon-overdue"></i> 欠款
            </el-radio>
            <el-radio label="部分还款" border size="medium">
              <i class="el-icon-warning-outline icon-partially-overdue"></i> 部分还款
            </el-radio>
            <el-radio label="还款完成" border size="medium">
              <i class="el-icon-check icon-paid"></i> 还款完成
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="还款方式:" prop="repaymentMethod">
          <el-input v-model="orderForm.repaymentMethod" placeholder="请输入还款方式" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="还款金额:" prop="paymentAmount">
          <el-input-number v-model="orderForm.paymentAmount" :precision="2" :step="0.1" style="width: 200px" :min="0.00" placeholder="请输入还款金额"></el-input-number>
        </el-form-item>
        <el-form-item label="收款凭证:" prop="receipt">
          <!-- 显示已上传的图片 -->
          <el-row :gutter="20" style="margin-top: 20px;">
            <el-col v-for="(url, index) in order.receipt" :key="index" :span="6">
              <el-image            style="width: 100%; height: 100px"
                                   :src="url"
                                   :preview-src-list="order.receipt"
                                   :z-index="2000">
              </el-image>
            </el-col>
          </el-row>
          <el-upload
              class="upload-demo"
              name="file"
              :action="this.$uploadURL"
              :on-remove="handleFileRemove"
              :on-success="handleFileUpload"
              :on-exceed="handleFileExceed"
              :multiple="true"
              :limit="5"
              :file-list="fileList"
              accept=".jpg,.png,.gif"
              list-type="picture">
            <el-button size="small" type="primary">新增凭证</el-button>
          </el-upload>
        </el-form-item>
        <el-button type="success" @click="uptoorder">确认还款</el-button>
      </el-form>

      <h3>订单产品信息</h3>
      <el-table :data="productList" style="width: 100%" border>
        <el-table-column prop="productName" label="产品名称"  :align="'center'"></el-table-column>
        <el-table-column prop="picture" label="产品图片"  :align="'center'">
          <template slot-scope="scope">
            <img :src="scope.row.picture" :preview-src-list="[scope.row.picture]" alt="Product Image"
                 style="width: 100px; height: 100px;">
          </template>
        </el-table-column>
        <el-table-column prop="price" label="产品价格"  :align="'center'"></el-table-column>
        <el-table-column prop="costPrice" label="售价"  :align="'center'"></el-table-column>
        <el-table-column prop="orderNum" label="选购数量"  :align="'center'"></el-table-column>
        <el-table-column prop="salePrice" label="成交价" :align="'center'"></el-table-column>
        <el-table-column prop="orderAmount" label="金额"  :align="'center'"></el-table-column>
      </el-table>
    </div>
    <div style="flex: 1.2; display: flex; flex-direction: column;">
      <div>
        <h5>订单信息</h5>
        <el-timeline :reverse="reverse">
          <el-timeline-item
              v-for="(item, index) in orderTimeList"
              :key="index"
              :color="getColor(item, index)"
          >
            <div :style="index === 0 ? { color: '#5EA8F8' } : {}">
              <span>{{ item.time }}</span>
              <el-tag :type="getTagType(item, index)" style="margin-left: 10px;">
                {{ item.operateType }}
              </el-tag>
            </div>
            <div style="margin-top: 8px; margin-bottom: 20px; font-size: 13px; color: gray;">
              {{ item.content }}
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div style="flex: 1;">
        <h5>还款信息</h5>
        <el-timeline :reverse="reverse">
          <el-timeline-item
              v-for="(item, index) in repayTimeList"
              :key="index"
              :color="getrePayColor(item, index)"
          >
            <div :style="index === 0 ? { color: '#5EA8F8' } : {}">
              <span>{{ item.time }}</span>
              <el-tag :type="getreypayTagType(item, index)" style="margin-left: 10px;">
                {{ item.style }}
              </el-tag>
            </div>
            <div style="margin-top: 8px; margin-bottom: 20px; font-size: 13px; color: gray;">
              {{ item.record }}
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'orderRepayment',
  data() {
    return {
      //描述组件
      labelstyle:{
        'width':'17vh',
      },
      contentStyle: {
        width: '25vh', // 设置内容的宽度
      },
      orderForm:{
        paymentStatus: '',
        repaymentMethod: '',
        paymentAmount: 0.00,
        receipt: []
      },
      rules:{
        repaymentMethod: [
          { required: true, message: '请输入还款方式', trigger: 'blur' }
        ],
        paymentAmount: [
          { required: true, message: '请输入还款金额', trigger: 'change' },
          { type: 'number', min: 0, message: '还款金额必须大于等于0', trigger: 'change' }
        ]
      },
      //时间线组件
      orderTimeList:[],
      //还款记录组件
      repayTimeList:[],

      reverse:false,
      repaymentMethod:'',//还款方式
      paymentAmount:null,//还款金额
      paymentStatus:'',//订单支付状态
      // showLargeImage: false,
      order: {
        employee: {},
        customer:{},
        receipt:[],
      },
      showLargeImageIndex: null,
      //订单编号
      copyOrderSn:'',
      acquisitionOrders: [],//所有订单
      fileList:[],
      // 客户级别
      custoLabel: [],
      // 客户销售渠道
      custoType: [],
      //客户来源
      custoSource: [],
      productList: [],
      orderReviewer: [],
      selectedAuditor: null, // 选中的审核人
      auditComment: '', // 审核备注
      logininfoId:null,//登录id
    };

  },
  methods: {
    //订单还款
    uptoorder(){
      // if (this.fileList.length === 0) {
      //   this.$message.warning('请上传新的收款凭证');
      //   return;
      // }
      this.$refs.orderForm.validate((valid)=>{
        if (valid) {

          const logininfo = JSON.parse(localStorage.getItem("logininfo"));
          this.logininfoId = logininfo.id;
          const para = {
            orderSn: this.copyOrderSn, // 订单编号
            receipt: this.order.receipt.join(","), // 支付凭证
            paymentStatus: this.orderForm.paymentStatus, // 支付状态
            paymentAmount: this.orderForm.paymentAmount, // 还款金额
            repaymentMethod: this.orderForm.repaymentMethod, // 还款方式
            loginId: this.logininfoId  // 操作人
          };
          this.$http.post("/orderList/orderRepayment", para).then(res => {
            if (res.data.success) {
              this.$message.success("订单还款记录成功");
              this.$router.go(-1);
            } else {
              this.$message.error("订单还款失败");
            }
          });
        } else {
          console.log('表单验证失败');
          this.$message.error('请填写必填项');
          return false;
        }
      });
    },
    fetchOrderDetail() {
      const orderSn = this.copyOrderSn; // 获取路由参数或 props
      if (orderSn) {
        this.$http.get(`/orderList/${orderSn}`)
            .then(response => {
              const data = response.data;
              if (data) {
                this.orderForm.paymentStatus=data.paymentStatus,
                this.order = {
                  ...data,
                  receipt: data.receipt ? data.receipt.split(',') : [],
                  voucher: data.voucher ? data.voucher.split(',') : [],

                };
              } else {
                console.error('Invalid response data structure');
                this.order = {}; // 或者设置为默认值
              }
            })
            .catch(error => {
              console.error('获取订单详情失败:', error);
            });
        //获取订单产品
        this.$http.post("/orderProducid/" + orderSn).then(res => {
          this.productList = res.data;
        });
      }
    },
    showLargeImage(index) {
      this.showLargeImageIndex = index;
    },
    //获取订单时间线
    getOrderTime() {
      const orderSn = this.copyOrderSn; // 获取路由参数或 props
      this.$http.post("/orderTime/" + orderSn).then(res => {
        const data = res.data;
        // 确保格式化每个时间项
        this.orderTimeList = data.map(item => ({
          ...item,
          time: this.$formatTimeNew(item.time)
        }));
      });
    },

    getOrderRepaymentTime() {
      const orderSn = this.copyOrderSn; // 获取路由参数或 props
      this.$http.post("/orderRepayment/" + orderSn).then(res => {
        const data = res.data;
        // 确保格式化每个时间项
        this.repayTimeList = data.map(item => ({
          ...item,
          time: this.$formatTimeNew(item.repaymentTime)
        }));
      });
    },
    //根据内容显示动态的图标
    getColor(item, index) {
      if (index === 0) {
        return "#5EA8F8";
      } else if (
          item.content.includes("订单审核未通过") ||
          item.content.includes("订单取消")
      ) {
        return "#F6665D";
      } else {
        return "#93F9A5";
      }
    },

      getrePayColor(item, index) {
        if (index === 0) {
          return "#5EA8F8"; // 默认颜色，当前项高亮为蓝色
        } else if (item.style.includes("部分还款")) {
          return "#FFD700"; // 蓝色，用于部分还款
        } else if (item.style.includes("欠款")) {
          return "#FF6333"; // 黄色，用于欠款
        } else if (item.style.includes("还款完成")) {
          return "#93F9A5"; // 绿色，用于欠款完成
        } else {
          return "#CCCCCC"; // 默认灰色，适用于其他情况
        }
      },
    getTagType(item, index) {
      if (index === 0) {
        return ""; // 默认类型（无样式）
      } else if (
          item.content.includes("订单审核未通过") ||
          item.content.includes("订单取消")
      ) {
        return "danger"; // 红色类型
      } else {
        return "success"; // 绿色类型
      }
    },
    getreypayTagType(item, index) {
      if (index === 0) {
        return ""; // 默认类型（无样式）
      } else if (item.style.includes("部分还款")) {
        return "warning"; // 蓝色类型
      } else if (item.style.includes("欠款")) {
        return "danger"; // 黄色类型
      } else if (item.style.includes("还款完成")) {
        return "success"; // 绿色类型
      } else {
        return ""; // 默认类型
      }
    },
    //文件删除时的回调
    handleFileRemove(file, fileList) {
      //正式删除
      var fileName = null;
      if (file.response) {  //上传图片的时候点了删除
        fileName = file.response.resultObj;
      } else {  //点击修改回显的图片，点了删除
        fileName = file.url;
      }
      //为了方便参数传递,需要转换路径写法,把/替换为_
      fileName = fileName.replaceAll("/", "_");
      //发送请求
      this.$http.delete("/minio/" + fileName).then(res => {
        if (res.data.success) {
          this.$message.success("删除成功");
          this.fileList = [];
          this.order.picture = "";
        } else {
          this.$message.error("删除失败");
        }
      })
    },

    //文件上传成功之后的回调
    handleFileUpload(response) {
      if (response.success) {
        this.order.receipt.push(response.resultObj) ;
      }
    },

    //上传超过数量的回调
    handleFileExceed() {
      this.$message.error("不能上传多张图片");
    },
    //获取客户数据信息
    gettypeNameById(typeId) {
      const category = this.custoType.find(item => item.id === typeId);
      return category ? category.customerType : '';
    },
    getlabelNameById(labelId) {
      const category = this.custoLabel.find(item => item.id === labelId);
      return category ? category.customerLabel : '';
    },
    getsourceNameById(sourceId) {
      const category = this.custoSource.find(item => item.id === sourceId);
      return category ? category.customerSource : '';
    },
    getReviewerNameById(reviewerKey) {
      const reviewer = this.orderReviewer.find(item => item.id === reviewerKey);
      return reviewer ? reviewer.adminName : '';
    },
    //获取类型
    getType() {
      this.$http.get("/customerType").then(res => {
        this.custoType = res.data;
      })
    },
    //获取标签
    getLabel() {
      this.$http.get("/customerLabel").then(res => {
        this.custoLabel = res.data;
      })
    },
    //获取来源
    getSerouce() {
      this.$http.get("/customerSource").then(res => {
        this.custoSource = res.data;
      })
    },
  },
  mounted() {
    const orderSn = this.$route.params.orderSn; // 从路由参数获取订单编号
    if (!orderSn) {
      // 如果订单编号不存在则跳转到我的订单
      this.$router.push({name: '我的订单列表'});
    }else{
      this.copyOrderSn=orderSn;
      this.fetchOrderDetail();
      this.getSerouce();
      this.getType();
      this.getLabel();
      this.getOrderTime();
      this.getOrderRepaymentTime();
    }
  }
};
</script>

<style scoped>
.border {
  border: 1px solid #dcdfe6; /* 边框颜色 */
  padding: 20px;            /* 内边距 */
  border-radius: 5px;       /* 可选，圆角 */
}
.el-radio .el-icon {
  margin-right: 8px;
}



.icon-paid {
  color: #67C23A; /* 已支付 - 绿色 */
}

.icon-overdue {
  color: #F56C6C; /* 欠款 - 红色 */
}

.icon-partially-overdue {
  color: #E6A23C; /* 部分欠款 - 黄色 */
}

.icon-completed {
  color: #409EFF; /* 还款完成 - 蓝色 */
}
textarea {
  width: 100%;
  height: 100px;
}
.image-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 5px; /* 图片之间的间距 */

}



</style>



// WEBPACK FOOTER //
// orderRepayment.vue?6ed0bb3c